import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import Page from '../components/dna/Page';
import NavBar from '../components/dna/NavBar';
import {injectIntl} from 'react-intl';
import {inject,toggleInject} from "../components/injector";



class Main extends React.PureComponent {

    componentDidMount(){
        // jssdk.setDeviceStatus({pwr:0});
        // jssdk.platformSDK.openDevicePropertyPage();
    }

    render(){
        const {pwr,intl,history} = this.props;
        return (
            <Page saveBottom>
                <NavBar exit title={intl.formatMessage({id:'title'})}/>
                <ul className={style.onlineH5}>
                    <li onClick={()=>history.push('/runlai')}>润莱隐私条款</li>
                    <li onClick={()=>history.push('/zhongx')}>中性隐私条款</li>
                    <li onClick={()=>history.push('/help')}>帮助</li>
                    <li onClick={()=>history.push('/falut')}>润莱故障说明</li>
                    <li onClick={()=>history.push('/falutzx')}>中性故障说明</li>
                </ul>
            
            </Page>
        )
    }
}



export default inject()(injectIntl(Main));